import { Component, OnInit, ElementRef  } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
declare var $: any;
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
@Component({
  selector: 'app-dependence',
  templateUrl: './dependence.component.html',
  styleUrls: ['./dependence.component.scss']
})
export class DependenceComponent implements OnInit {

  currentLang: any;
  public dependenceForm: FormGroup;
  public todayDate: any = new Date();
  isSubmitted = false;
  response: any;
  uuid: any;
  dependenceData: any;
  responseupload: any;
  id_Front_photo: any;
  id_Back_Photo: any;
  employee_Photo: any;
  dependenceEditData: any;
  showDetails = false;
  birth_certificate_url: any;
  accountDetails: any;
  childWithDisability: any;
  childCertificate_url: any;
  prenatalCheckup_url: any;
  interviewCertificate_url: any;
  paternityCertificate_url: any;
  medicalCertificate_url: any;
  certificate_childBirth_url: any;
  nonEnrolment_url: any;
  nonFamily_url: any;
  minDate: Date = new Date();
  id: any;
  childAge: number;
  afterView = false;
  constructor(private formBuilder: FormBuilder,
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private location: Location,
    private elementRef: ElementRef,
    private ngxUiLoaderService: NgxUiLoaderService) {

    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      console.log("40 accounts", this.accountDetails)
      const updatedDate = new Date(this.accountDetails.dob);
      updatedDate.setFullYear(updatedDate.getFullYear() + 16);
      this.minDate = updatedDate;
      this.minDate.setHours(0, 0, 0, 0);
      console.log("mindate", this.minDate)
      this.afterView = false;
    }


    if (this.router.getCurrentNavigation().extras.state) {
      this.uuid = this.router.getCurrentNavigation().extras.state.data;
      this.showDetails = false;
    }
    if (this.route.snapshot.paramMap.get('id')) {
      this.showDetails = true;
      this.id = this.route.snapshot.paramMap.get('id');
      this.getDependenceDetails(this.id);
    }
  }
  ngOnInit() {
    this.dependenceForm = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-Z0-9À-ÖØ-öø-ÿ,'` -]+$")]],
      lastName: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-Z0-9À-ÖØ-öø-ÿ,'` -]+$")]],
      mob: ['', [Validators.pattern("^[0-9]*$"), Validators.pattern(/^(77|76|74|66|65|62|60|61)\d{6}$/), Validators.minLength(8), Validators.maxLength(8)]],
      relation: ['2', [Validators.required]],
      dob: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      profile_photo: ['', [Validators.required]],
      birthCertificate: ['', [Validators.required]],
      spouse_first_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-Z0-9À-ÖØ-öø-ÿ,'` -]+$")]],
      spouse_last_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-Z0-9À-ÖØ-öø-ÿ,'` -]+$")]],
      spouse_cnss_no: ['', [Validators.pattern("^\\d{3}-\\d{3,10}-[A-Z]$")]],
      spouse_cnamgs_no: ['', [Validators.pattern(/^\d{3}-\d{3}-\d{3}-\d{3}$/)]],
      spouse_cppf_no: [''],
      occupation: [''],
      id_front_photo: [''],
      illness: [''],
      id_back_photo: [''],
      childCertificate: [''],
      prenatalCheckup: [''],
      interviewCertificate: [''],
      medicalCertificate: [''],
      certificateChildBirth: [''],
      nonAllowanceCertificate: [''],
      nonEnrolmentCertificate: [''],
      paternityCertificate: ['']
    });
    // if (!this.api.getValidationStatus()) {
    //   this.api.getFormValidation(this.dependenceForm);
    // }
    this.currentLang = localStorage.getItem('language') || "fr";
    console.log("104", this.currentLang)

  }

  upload(event, id) {

    console.log("2250", event)
    console.log("2251", event.target.files[0])

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('uploaded image: ', file)
      const filename = file.name;
      var ext = filename.split('.').pop();

      if (file.size > 5242880) {

        if (this.currentLang == 'fr') {
          alert('La taille du fichier doit être inférieure à 5MB')
        } else {
          alert('File Size should be less than 5MB')
        }
        return;
      }
      if (id == 'photoFileName') {
        console.log("541  Employee Photo")
        if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg' && ext != 'bmp' && ext != 'BMP' && ext != 'webp' && ext != 'heic' && ext != 'HEIC' && ext != 'heif' && ext != 'HEIF' && ext != 'tiff' && ext != 'TIFF' && ext != 'tif' && ext != 'TIF') {
          if (this.currentLang == 'fr') {
            alert('Type de fichier non autorisé. Les types de fichier autorisés sont  .jpg .png .jpeg .bmp .webp .heic .heif .tiff')
          } else {
            alert('File type not allowed. Allowed file types are .jpg .png .jpeg .bmp .webp .heic .heif .tiff')
          }
          return;
        }
      } else {

        if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg' && ext != 'pdf' && ext != 'PDF' && ext != 'doc' && ext != "DOC" && ext != 'docx' && ext != 'DOCX' && ext != 'bmp' && ext != 'BMP' && ext != 'webp' && ext != 'heic' && ext != 'HEIC' && ext != 'heif' && ext != 'HEIF' && ext != 'tiff' && ext != 'TIFF' && ext != 'tif' && ext != 'TIF') {
          if (this.currentLang == 'fr') {
            alert('Type de fichier non autorisé. Les types de fichier autorisés sont .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
          } else {
            alert('File type not allowed. Allowed file types are .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
          }
          return;
        }
      }



      const target = event.target.dataset.target;
      console.log(target)
      const formData = new FormData();
      formData.append('image', file);
      formData.append('target', target);
      console.log("file is :", file)
      console.log("target is :", target)
      formData['encrypt_mode'] = false;
      // formData['encrypt_mode'] = false;
      // formData.append('uuid', this.businessData.business_code);
      this.ngxUiLoaderService.start();
      this.api.dependenceUpload(formData).pipe(first())
        .subscribe(data => {
            this.ngxUiLoaderService.stop();
            this.responseupload = data;
            if (this.responseupload.status == 200) {
              this.snackBar.open(data.message, "OK", {
                duration: 5000,
              });
              if (target == 'id_front_photo') {
                this.dependenceForm.get('id_front_photo').setValue(this.responseupload.results.file);
                this.id_Front_photo = this.responseupload.results.imageUrl;
              }
              if (target == 'id_back_photo') {
                this.dependenceForm.get('id_back_photo').setValue(this.responseupload.results.file);
                this.id_Back_Photo = this.responseupload.results.imageUrl;
              }
              if (target == 'profile_photo') {
                this.dependenceForm.get('profile_photo').setValue(this.responseupload.results.file);
                this.employee_Photo = this.responseupload.results.imageUrl;
              }
              if (target == 'birth_certificate') {
                console.log("185")
                this.dependenceForm.get('birthCertificate').setValue(this.responseupload.results.file);
                console.log(this.dependenceForm.get('birthCertificate').value)
                this.birth_certificate_url = this.responseupload.results.imageUrl;
                console.log("185", this.birth_certificate_url)
              }
              if (target == 'childCertificate') {
                this.dependenceForm.get('childCertificate').setValue(this.responseupload.results.file);
                this.childCertificate_url = this.responseupload.results.imageUrl;
              }
              if (target == 'prenatal_certificate') {
                this.dependenceForm.get('prenatalCheckup').setValue(this.responseupload.results.file);
                this.prenatalCheckup_url = this.responseupload.results.imageUrl;
              }
              if (target == 'interview_certificate') {
                this.dependenceForm.get('interviewCertificate').setValue(this.responseupload.results.file);
                this.interviewCertificate_url = this.responseupload.results.imageUrl;
              }
              if (target == 'medical_certificate') {
                this.dependenceForm.get('medicalCertificate').setValue(this.responseupload.results.file);
                this.medicalCertificate_url = this.responseupload.results.imageUrl;
              }
              if (target == 'certificate_ChildBirth') {
                this.dependenceForm.get('certificateChildBirth').setValue(this.responseupload.results.file);
                this.certificate_childBirth_url = this.responseupload.results.imageUrl;
              }
              if (target == 'non_Allowance_Certificate') {
                this.dependenceForm.get('nonAllowanceCertificate').setValue(this.responseupload.results.file);
                this.nonFamily_url = this.responseupload.results.imageUrl;
              }
              if (target == 'non_Enrolment_Certificate') {
                this.dependenceForm.get('nonEnrolmentCertificate').setValue(this.responseupload.results.file);
                this.nonEnrolment_url = this.responseupload.results.imageUrl;
              }
              if (target == 'paternity_certificate') {
                this.dependenceForm.get('paternityCertificate').setValue(this.responseupload.results.file);
                this.paternityCertificate_url = this.responseupload.results.imageUrl;
              }
            } else {
              this.snackBar.open(data.message, "OK", {
                duration: 5000,
              });
            }

          },
          error => {});

    }
  }


  ngAfterViewInit(): void {


    setTimeout(() => {
      this.afterView = true;

      if (this.afterView) {
        this.setValidators();
      }

    }, 0);
  }
  editForm() {
    // document.getElementById("dependenceDetails").style.display = "none";
    // document.getElementById("dependenceCreate").style.display = "block";
    this.showDetails = false;
    this.editDependence();
  }

  onSubmitDependence() {
    this.isSubmitted = true;
    if (this.dependenceForm.invalid) {
      console.log(this.dependenceForm)
      this.scrollToFirstInvalidControl()
      return;
    }
    var data = this.dependenceForm.value;
    console.log(this.dependenceForm)
    console.log(data)
    data.nominie_id = this.id;
    console.log("173", data)
    this.dependenceData = data;
    this.dependenceData['dob'] = this.dateconverter(this.dependenceForm.get('dob').value);
    // this.dependenceData['employee_Photo'] = this.employee_Photo;
    // this.dependenceData['id_Front_photo'] = this.id_Front_photo;
    // this.dependenceData['id_Back_photo'] = this.id_Back_Photo;
    console.log("179", this.dependenceData)
    this.ngxUiLoaderService.start();
    this.api.submitDependantsDetails(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
            this.router.navigate(['/dependence-list']);
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });

    // if (this.dependenceData) {
    //   document.getElementById("dependenceCreate").style.display = "none";
    //   document.getElementById("dependenceDetails").style.display = "block";
    // }
  }

  // submitDependantsDetails() {
  //   var data = this.dependenceForm.value;
  //   this.api.submitDependantsDetails(data).pipe(first())
  //     .subscribe(data => {
  //         this.response = data;
  //         if (this.response.status == 200) {
  //           this.router.navigate(['/dependence-list']);
  //         } else {
  //           this.snackBar.open(this.response.message, "OK", {
  //             duration: 5000,
  //           });
  //         }
  //       },
  //       error => {
  //         this.ngxUiLoaderService.stop();
  //       });
  // }

  getDependenceDetails(data) {
    this.ngxUiLoaderService.start();
    this.api.getDependenceDetails(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            $('#dependenceCreate').css('display', 'none');
            $('#dependenceDetails').css('display', 'block');
            this.dependenceData = this.response.results;

          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  editDependence() {
    this.ngxUiLoaderService.start();
    this.api.getDependenceData(this.id).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.dependenceEditData = this.response.results;
            this.setFieldValue()
            console.log("247", this.response)
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  showForm() {
    this.location.back();
    // if (this.uuid == 1) {
    //   this.showDetails = false;
    // } else {
    //   this.router.navigate(['/dependence-list']);
    // }
  }
  get f() {
    return this.dependenceForm.controls;
  }

  dateconverter(val) {
    const date = new Date(val);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;
    console.log(formattedDate);
    return formattedDate;
  }
  setFieldValue() {
    console.log("284")

    this.dependenceForm.controls['relation'].setValue('2');
    this.dependenceForm.controls['relation'].updateValueAndValidity();
    this.childAge = this.dependenceEditData.age;
    this.dependenceForm.controls['firstName'].setValue(this.dependenceEditData.first_name);
    this.dependenceForm.controls['lastName'].setValue(this.dependenceEditData.last_name);
    this.dependenceForm.controls['mob'].setValue(this.dependenceEditData.mobile);
    this.dependenceForm.controls['dob'].setValue(this.dependenceEditData.dob);
    this.dependenceForm.controls['gender'].setValue(this.dependenceEditData.gender);
    // this.dependenceForm.controls['marital_status'].setValue(this.dependenceEditData.marital_status);
    // this.dependenceForm.controls['occupation'].setValue(this.dependenceEditData.occupation);
    this.dependenceForm.get('id_front_photo').setValue(this.dependenceEditData.id_front_photo_name);
    this.dependenceForm.get('id_back_photo').setValue(this.dependenceEditData.id_back_photo_name);
    this.dependenceForm.get('profile_photo').setValue(this.dependenceEditData.profile_photo_name);
    this.dependenceForm.get('birthCertificate').setValue(this.dependenceEditData.birthCertificate_name);
    this.dependenceForm.get('spouse_first_name').setValue(this.dependenceEditData.spouse_first_name);
    this.dependenceForm.get('spouse_last_name').setValue(this.dependenceEditData.spouse_last_name);
    this.dependenceForm.get('spouse_cnss_no').setValue(this.dependenceEditData.spouse_cnss_no);
    this.dependenceForm.get('spouse_cnamgs_no').setValue(this.dependenceEditData.spouse_cnamgs_no);
    this.dependenceForm.get('spouse_cppf_no').setValue(this.dependenceEditData.spouse_cppf_no);
    this.dependenceForm.get('childCertificate').setValue(this.dependenceEditData.childCertificate_name);
    this.dependenceForm.get('prenatalCheckup').setValue(this.dependenceEditData.prenatal_checkup_name);
    this.dependenceForm.get('interviewCertificate').setValue(this.dependenceEditData.interview_certificate_name);
    this.dependenceForm.get('medicalCertificate').setValue(this.dependenceEditData.medical_certificate_name);
    this.dependenceForm.get('certificateChildBirth').setValue(this.dependenceEditData.certificateChildBirthName);
    this.dependenceForm.get('nonAllowanceCertificate').setValue(this.dependenceEditData.non_allowance_certificate_name);
    this.dependenceForm.get('nonEnrolmentCertificate').setValue(this.dependenceEditData.non_enrolment_certificate_name);
    this.dependenceForm.get('paternityCertificate').setValue(this.dependenceEditData.paternity_certificate_name);
    this.dependenceForm.get('occupation').setValue(this.dependenceEditData.occupation);
    this.dependenceForm.get('illness').setValue(this.dependenceEditData.illness);
    const illness = this.dependenceForm.controls['illness'].value
    if (illness == 1) {
      this.childWithDisability = true
    } else {
      this.childWithDisability = false;
    }
    this.id_Front_photo = this.dependenceEditData.id_front_photo;
    this.id_Back_Photo = this.dependenceEditData.id_back_photo;
    this.employee_Photo = this.dependenceEditData.profile_photo;
    this.birth_certificate_url = this.dependenceEditData.birthCertificate;
    this.childCertificate_url = this.dependenceEditData.childCertificate;
    this.prenatalCheckup_url = this.dependenceEditData.prenatal_checkup;
    this.interviewCertificate_url = this.dependenceEditData.interview_certificate;
    this.medicalCertificate_url = this.dependenceEditData.medical_certificate;
    this.certificate_childBirth_url = this.dependenceEditData.certificateChildBirth;
    this.nonFamily_url = this.dependenceEditData.non_allowance_certificate;
    this.nonEnrolment_url = this.dependenceEditData.non_enrolment_certificate;
    this.paternityCertificate_url = this.dependenceEditData.paternity_certificate;

  }

  deleteDependence() {

    let data = {
      nominie_id: this.id
    }
    this.ngxUiLoaderService.start();
    console.log(data)
    this.api.deleteDependent(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
            $('#dependence-confirm-modal').modal('hide');
            this.router.navigate(['/dependence-list']);

          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  goback() {
    this.location.back();
  }
  onDobChange(date) {
    this.dependenceForm.get('childCertificate').setValue(null);
    this.childCertificate_url = null;
    console.log("379", date)
    let dateString = date;
    let birthDate = new Date(dateString);

    let currentDate = new Date();

    let age = currentDate.getFullYear() - birthDate.getFullYear();
    if (
      currentDate.getMonth() < birthDate.getMonth() ||
      (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    this.childAge = age;
    console.log("Age:", this.childAge);
  }

  onCheckboxChange(e) {
    console.log(e.target.checked)
    this.childWithDisability = e.target.checked;
    this.dependenceForm.get('childCertificate').setValue(null);
    this.childCertificate_url = null;
  }
  setValidators() {
    if (this.accountDetails.marital_status != '2' || this.accountDetails.marital_status != '5') {
      this.f['spouse_first_name'].setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-Z0-9À-ÖØ-öø-ÿ,'` -]+$")]);
      this.f['spouse_first_name'].updateValueAndValidity();
      this.f['spouse_last_name'].setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-Z0-9À-ÖØ-öø-ÿ,'` -]+$")]);
      this.f['spouse_last_name'].updateValueAndValidity();

      console.log("workingggggggggggg")
    }
  }
  formatCnss(event: any) {
    let value = event.target.value.replace(/-/g, '');

    if (value.length >= 4 && value.length < 11) {
      value = value.slice(0, 3) + '-' + value.slice(3);
    } else if (value.length >= 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 10) + '-' + value.slice(10);
    }

    // Capitalize the last letter
    if (value.length > 0) {
      value = value.slice(0, -1) + value.slice(-1).toUpperCase();
    }

    this.dependenceForm.patchValue({ spouse_cnss_no: value });
  }
  formatCnamgs(event: any) {
    let value = event.target.value.replace(/-/g, '');

    // Insert hyphens based on the length of the value
    if (value.length >= 4 && value.length < 7) {
      value = value.slice(0, 3) + '-' + value.slice(3);
    } else if (value.length >= 7 && value.length < 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
    } else if (value.length >= 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 9) + '-' + value.slice(9);
    }

    this.dependenceForm.patchValue({ spouse_cnamgs_no: value });
  }
  scrollToFirstInvalidControl() {
    for (const controlName in this.dependenceForm.controls) {
      const control = this.dependenceForm.get(controlName);
      if (control.invalid) {
        const firstInvalidControl = this.elementRef.nativeElement.querySelector(`[formcontrolname="${controlName}"]`);
        if (firstInvalidControl) {
          firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          break;
        }
      }
    }
  }

}
